import React from 'react';
import Radio from 'emerald-ui/lib/Radio';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Radio, componentName: 'Radio' }], 'Radio'),
  description: (
    <span>
      A Radio allows to choose an option among several options. Radio supports only a controlled use, which means you
      must manage the checked state. If you don‘t want to control it, use <span className="code">RadioGroup</span>.
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { Radio },
      whiteBackground: true,
      code: `class ControlledRadio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checkboxes: [
        {
          value: 'one',
          checked: false
        },
        {
          value: 'two',
          checked: true
        },
        {
          value: 'three',
          checked: false
        }
      ],
      selected: 'two'
    };

    this.handleChange = this.handleChange.bind(this);
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handleChange = event => {}
  handleChange(event) {
    const selected = event.target.value;

    console.log('Selected', selected);

    this.setState(prevState => {
      const values = prevState.checkboxes;

      const newValues = values.map(cb => {
        const { value } = cb;

        return { value, checked: value === selected };
      });

      return { checkboxes: newValues };
    });
  }

  renderCheckboxes() {
    return this.state.checkboxes.map((checkbox, index) => (
      <Radio
        key={'radio-' + index}
        id={'radio-' + index}
        label={checkbox.value}
        checked={checkbox.checked}
        value={checkbox.value}
        onChange={this.handleChange}
      />
    ));
  }

  render() {
    return <div>{this.renderCheckboxes()}</div>;
  }
}`,
    },
  ],
};
